import { Injectable, ApplicationRef } from '@angular/core';
import { WsService2 } from '../services/ws/ws.service';
import { NetworkService } from './network.service';
import { WbService } from '../wb.service';
import { environment } from '../../../environments/environment';

//import { RecordingManagerService } from '../services/recording/recording-manager.service';
import { SessionManagerService } from '../services/session/session-manager.service';
import { LayoutManagerService } from '../services/layout/layout-manager.service';
declare var $;
declare var chrome;
declare var videojs;
export interface OnReplayer {
  onStartPlaying();
  onStopPlaying();
  isReady();
}

@Injectable()
export class ReplayerService {
  public extId;
  
  constructor(private network: NetworkService,
    private wbService: WbService,
    private sessionManager: SessionManagerService,

    private layoutManagerService: LayoutManagerService,
    private ws: WsService2, private appRef: ApplicationRef,
  //    private recordingManager:RecordingManagerService, 
  ) { }
  cleanPlayers() {
    console.log("Cleanng players")
    this.stopPlaying();
    if (this.handler) {
      clearInterval(this.handler)
    }
  }


  playerComponent: OnReplayer;
  registerForReplaying(c: OnReplayer) {
    this.playerComponent = c
  }
  startPlaying() {

    this.playerComponent.onStartPlaying();
    this.playing = true;
    for (let p in this.players) {
      try {

        this.players[p].play()
      } catch (err) { }
    }
  }
  playing = false;
  getUserHash() {
    return this.userHash;
  }
  isPlaying() {
      return this.playing;

  }
  stopPlaying() {
    this.playerComponent.onStopPlaying();
    console.log(this.playerComponent)
    this.playing = false;
    for (let p in this.players) {
      try {
        this.players[p].pause()
      } catch (err) { }
    }
  }
  handler
  userHash;
  recordContainerId;
  getCurrentRecordId() {
    return this.record.id;
  }
  setRecordContainerId(recordContainerId) {
    this.recordContainerId = recordContainerId;
  }
  getRecordContainerId() {
    return this.recordContainerId;
  }
  setUserHash(hash) {
    this.userHash = hash;
  }
  currentTime = 0;
  files = [];
  //endTime = 0;
  startTime;
  end = 0;
  next = 0;
  currentPeers = [];
  isLoading(){
    return this.loading;
  }

  playInSeek(r) {
    this.resetCurrents();
    var self = this;
    var last;
    
    for (let s of r.sessions) {
      if (s.dateCreated < this.currentTime) {
        last = s;
      }
    }

    if (!last) return;
    self.cs = last;

    self.sessionManager.boards = [];
    for (let i = 1; i < 3; i++) {
      if (!last.columns[i]) continue;
      var lastp;
      for (let cp of last.columns[i]) {
        if (cp.dateCreated < this.currentTime)
          lastp = cp;
      }
      if (!lastp) return;
      self.cp[i] = lastp;
      console.log("Setting board ", lastp);

      self.sessionManager.boards[i - 1] = lastp;
      self.sessionManager.boards = self.sessionManager.boards.slice();

      if (lastp.states) {
 
        setTimeout(function () {
            self.sessionManager.clearStates();
       // setTimeout(function(){
         self.setCurrentStates(r);//should load boards here

          for (let s of lastp.states) {
            
            if (s.dateCreated < self.currentTime) {
              self.sessionManager.onState(JSON.parse(s.serialized), lastp.id);
              self.cst[i] = s;
            }
          }
          //cb()
        }, 0);
      }
      /*setTimeout(function () {
        
      }, 50);*/
    }
  }
  resetCurrents() {
    this.cs = { id: 0 };
    this.cp = { 1: { id: 0 }, 2: { id: 0 } };
    this.cst = { 1: { id: 0 }, 2: { id: 0 } };
  }
  record
  sessions;
  cs = { id: 0 };
  cp = { 1: { id: 0 }, 2: { id: 0 } };
  cst = { 1: { id: 0 }, 2: { id: 0 } };
  private disposePlayers() {
    for (let p in this.players) {
      try {
        this.players[p].dispose();
      } catch (e) { }
    }
    this.players = [];

  }
  private checkCurrentPeers() {

    let arr = [];
    var founds = {}
    for (let k in this.currentPeers) {
      var p = this.currentPeers[k];
      for (let ki in p) {
        var f = p[ki].p;
  //      console.log("Current time "+this.currentTime+", "+p[ki]["in"]);
        if (p[ki]["in"] <= this.currentTime && p[ki].out > this.currentTime) {
          founds[f.userHash] = true

          if (this.peers[f.userHash]) continue;
          console.log("Got user " + f.name)
          console.log("Adding ", f);
          this.peers[f.userHash] = { who: f.userHash, name: f.name };
        }
      }

    }
    for (let p in this.peers) {
      if (!founds[p]) {
        console.log("Deleting " + f.name);
        delete this.peers[f.userHash];
        this.disposePlayer(f.userHash)

      }
    }

  }
 /* saveDatesForSeek(arr) {
    for (let p of arr) {
      if (p.date)
        p.origDate = p.date;
      else if (p.start) {
        p.origDate = p.start;
      }
    }
  }
 /* private updateExistingFilesDates() {
    this.updateExistingObjectDates(this.files);
  }
  private saveFilesDatesForSeek() {
    this.saveDatesForSeek(this.files);
  }
*/

  checkFiles() {

    let arr = [];
    var sharing = false;
    for (var f of this.files) {

      if (f.start <= this.currentTime && this.currentTime < f.end ) {
        
        if (f.media == 'sharescreen') {
          sharing = true;
          arr[f.who+"sharing"] = f;
        }else{
          arr[f.who] = f;
        }
      }
    }

    //console.log("checkFiles", arr)
    this.sharing = sharing;
    var self = this;

    for (let a in arr) {

      if (arr[a].media!='sharescreen' && (!this.peers[a] || $("#video-" + a).length == 0)) {
        console.error("Peer " + a + " has no container for the media...", this.peers, this.players, $("#video-" + a));
        console.log(arr[a]);
        continue;
      }
      if (arr[a].media != "sharescreen") {
        this.peers[a].media = arr[a].media;
       // this.appRef.tick()
      }

      setTimeout(function () {//after media is set we need a tick
        //  console.log("Setting both to " + a + " and " + self.peers[a].media);
        var id;
        if (arr[a].media == "sharescreen") {
          id = "video-sharing"

        } else {
          id = "video-" + a;
        }
        try {
          var setTime = false;
          if (!self.players[a]) {
            self.players[a] = videojs(id, { inactivityTimeout: 0, language: "bg" });
            self.players[a].src(environment.contentsBackendMediaUrl + arr[a].filename);
            setTime = true;
            self.peers[a]["snapshot"]=null;
        }

          if(self.players[a].src() != environment.contentsBackendMediaUrl + arr[a].filename) {
            self.players[a].src(environment.contentsBackendMediaUrl + arr[a].filename);
          }
          var ft = (self.currentTime - arr[a].start);
          
          if (ft > 0 && Math.abs(self.players[a].currentTime() - ft / 1000) > 1&&setTime) {
            self.players[a].currentTime(ft / 1000);
            
            self.players[a].play();
            console.log("Will play at ", ft)
          } 
        } catch (error) { console.error(error) }
        
      }, 50);

    }
  }
  /*private savePeersDatesForSeek() {
    this.saveDatesForSeek(this.currentPeers);
  }
  */fixFiles(){
    var arr = this.files;
        console.log("fix files",this.files)
    
    for (let key in this.files){
      if (!this.files[key]["end"]){
       this.files[key]["end"] = this.end
      }
    }
    console.log("Fixed files", this.files)
  }
  fixCurrentPeers() {
    var arr = this.currentPeers;
    var ofs = 0;
    var peers = [];
    for (let ki in arr) {
      var p = arr[ki];
      var hash = p.userHash;
      if (!peers[hash]) {
        peers[hash] = [];

      }
    
      ofs = peers[hash].length
      if (p.entered)  {
        if (ofs>0 && peers[hash][ofs-1]["in"]==p.date)continue
        peers[hash][ofs] = { "in": p.date, "p": p };
      
      } else {
        if (peers[hash][ofs-1]["out"])continue
        peers[hash][ofs-1]["out"] = p.date;
        
      }
    }
    console.log("Will fix peers")
    for (let key in peers) {
      for (let pkey in peers[key]) {
        if (!peers[key][pkey]["out"]) {

          console.log("Setting out to " + this.end);
          peers[key][pkey]["out"] = this.end;
        }
      }
    }
console.log("Peers are ", peers)
    this.currentPeers = peers;
  }



  records = [];
  endOfRecordingContainer = 0;
  interval = 100;
  ended;
  hasEnded() {
    return this.ended;
  }
  errorCb;
  registerForError(cb) {
    this.errorCb = cb;
  }
  showError() {
    this.errorCb.showError();
  }
  containerHash
  public setFromContents(containerHash) {
    this.containerHash = containerHash
  }
  reload
  getCurrentObject(arr){
    var found;
        for (let a of arr){
          if (a.dateCreated<=this.currentTime)
            found = a;
        }
        return found;
  }
  loadingCb;
  registerForLoading(cb){
    this.loadingCb = cb;
  }
  public play(preload = false, fncb=null) {
    this.preload = preload;
    console.log("Will start playing");
    this.layoutManagerService.updateLayout();
    var self = this;
   
    //  this.processVideos();
    this.ended = false;
    var url;
    if (this.containerHash != null) {
      url = "content/" + this.containerHash;
    } else {
      url = "session/" + this.userHash + "/" + this.recordContainerId;
    }
    self.loading(true)
    this.network.post(url, null, this.shouldRecord).subscribe(records => {
      self.loading(false)
      if (records && records.status == false) {
        if (self.shouldRecord){
          self.notifyRecordingFailed(null);
        }
        self.showError();

        return;
      }
      console.log("records", records)
      self.next = 0;
      self.disposePlayers();
      self.peers = [];
      self.endOfRecordingContainer = 0;
      for (let r of records) {
        self.endOfRecordingContainer += r.end - r.start;
      }
      console.log("Time is " + self.endOfRecordingContainer);
      if (self.handler) clearInterval(self.handler);
      var record;
      self.records = records;
      self.resetCurrents()
      self.playing = true;
      self.handler = setInterval(function () {
      
        if (!self.isPlaying()) return;

        if (self.next == 0 || self.currentTime >= self.end || self.reload) {
        //  self.clearLastObjects();
          if (self.next == records.length) {
            console.log("Done");
            self.ended = true;
            self.stopPlaying();
            chrome.runtime.sendMessage(self.extId, {text: 'start'});
            return;
          }

          record = records[self.next++];
           if (self.record && record.id!=self.record.id)
            self. clearLastObjects()
            self.record = record;
          console.log("WOrking wirh record ", record);
          if (!self.reload){
            
            self.currentTime = record.start;
          }
          self.reload = false;
          self.startTime = record.start;
          self.files = record.files;
          console.log("Setting files ", self.files);
     
          self.currentPeers = record.currentPeers;
  //        self.sessions = record.sessions;
        self.sessions=[];
        for (var i =0;i<record.sessions.length;i++){
          self.sessions.push(JSON.parse(record.sessions[i]));
        }
       //   console.log("Current time is " + (self.currentTime - self.startTime))

          self.end = record.end;
          console.log("sessions", self.sessions);
          self.peers = [];
          self.fixCurrentPeers();
          self.fixFiles();
         
        }
        //    console.log("Will check peers and files")
        self.checkCurrentPeers();
        setTimeout(function () {
          self.checkFiles()
        }, 0);

       // var s = self.getCurrent(self.cs, self.sessions);
        self.draw(record);
      
        self.currentTime += self.interval;
        var ct = 0;
        for (let r of records){
          if (r.id == record.id)
          break;
          ct += r.end-r.start;
        }
        self.val = (ct+self.currentTime - self.startTime) / self.endOfRecordingContainer * 100;
      
        if (self.snapshotStart ==0 || self.snapshotStart<=self.currentTime-self.snapshotInterval){
          self.snapshotStart = self.currentTime;
          
          var caller =self.userHash
          var end = self.snapshotStart+self.snapshotInterval;
          self.network.post("snapshots", {recordContainerId: self.recordContainerId, containerHash: self.containerHash, 
            start: self.snapshotStart, end: end}, true).subscribe(snapshots => {
            console.log("Snapshot response", snapshots)
            self.snapshots = snapshots
        }, error=>{});
        }
        if (self.snapshots){
          for (let i =0;i<self.snapshots.length;i++){
            var s = self.snapshots[i];
        //    console.log("Snapshot found ", s);
            if (s.date>self.currentTime){
             // for (let c of self.peers){
                var c = self.peers[s.caller];
                if (c.snapId!=s.id){
                  console.log("Snapshot, got peer", c.userHash)
                  c.snapshot = s.snapshot;
                  c.snapId = s.id
                }
              //}
              break;
            }
          }
        }
       
      }, self.interval);
    }, error => {
      self.notifyRecordingFailed(error);
    })

  }
  notifyRecordingFailed(error){

    this.loading(false)
    console.log("Got error while getting data", error)
    if (this.shouldRecord){
      this.network.postRecordingFailed(this.containerHash).subscribe(o=>{
        console.log("Could not record the video")
        window.close();
      }, error=>{
        console.log("Got error ", error);
        //window.close();
      });
    }
  }
  snapshotStart=0;
  snapshotInterval= 10000;
  snapshots=[];
  shouldRecord= false;
  loading(loading){
    if(this.loadingCb)
    this.loadingCb.onLoading(loading)
  } 
  preload = false;
  val;
  lastColumns={};
  lastState={}
  lastSession={}
  draw(record){
    var self = this;
    var s = self.getCurrentObject(self.sessions);
   var drawOldStates=false;
        if (!s) return;
         if (!self.lastSession || self.lastSession["id"]!=s.id){
      drawOldStates = true;
      self.lastSession = s;
      self.sessionManager.boards=[];
    }
        for (let i = 1; i < 3; i++) {
          if (!s.columns[i]) continue;
          var currentColumn = self.getCurrentObject(s.columns[i]);
          //if (!s.lastColumns)s.lastColumns=[];
          var slc = self.lastColumns[i];
          if (!slc||slc.id!=currentColumn.id){
            self.lastColumns[i]=currentColumn;
            self.sessionManager.boards[i - 1] = currentColumn;
            self.sessionManager.boards = self.sessionManager.boards.slice();
            self.appRef.tick()
            self.wbService.onResize();
          }
        }
        if (!record.currentStateProccessed) {
      //    setTimeout(function () { 
          self.sessionManager.clearStates();
          self.setCurrentStates(record);
      // }, 0);
          record.currentStateProccessed = true;
        }
       
        for (let lck in self.lastColumns){
          var lc = self.lastColumns[lck];
          if (lc.states){
            var ls = self.lastState[lck];
            if (!ls)ls={id:0}
            for (let state of lc.states){
              
              if ((ls.id<state.id||record.processStatesAfterSeek || drawOldStates)&&state.dateCreated<=self.currentTime){
                console.log("Drawing ");
                self.sessionManager.onState(JSON.parse(state.serialized), lc.id);
                self.lastState[lck] = state;
                if (!record.processStatesAfterSeek && !drawOldStates)
                  break;
              }
            }

           
          }
           
        }
        record.processStatesAfterSeek=false;
  }
  setCurrentStates(record) {
    var self = this;
    console.log("Setting current states")
    for (let p of record.currentPages) {
      console.log("Will set current state ",p);
      self.sessionManager.notifyCallbacksAboutCurrentState({ currentState: p.currentState, pageId: p.id });
      
    }
  }
  private getCurrent(o, arr, checkStart = false) {
    for (let a of arr) {
      if (!o || (o.id < a.id) && ((!checkStart || this.startTime <= a.dateCreated) && a.dateCreated <= this.currentTime)) {
        console.log("Got element at " + new Date(a.dateCreated))
        console.log("Element: ",  a)
        return a;
      }
    }
    return o;
  }
  showSessionBoards(s) {
    console.log("showSessionBoards", s)
    var bs = [];
    for (let i = 1; i < 3; i++)
      if (s.columns[i]){
        var found ;
        for (let c of s.columns[i]){
          if (c.dateCreated<=this.currentTime)
            found = c;
        }
        bs.push(found);
      }
    console.log("Got boards ", bs);
    this.sessionManager.boards = bs;
  }
  peers = [];
  players = [];
  private disposePlayer(hash) {
    if (!this.players[hash]) return;
    try {
      this.players[hash].dispose();
    } catch (err) {

    }
    delete this.players[hash];
  }


  sharing;
  seek(percent) {
try {
  //    this.stopPlaying();
    } catch (err) { }
    var ct = this.endOfRecordingContainer * percent;
    var sum = 0;
    var seekedNext = 0;
    var self = this;
    
    var currentRecord;
        for (let r of this.records) {
           r.currentStateProccessed=false
        }
    for (let r of this.records) {
     
      sum += r.end - r.start;
      console.log("Got sum "+sum+ " and ct "+ct);
      if (ct < sum) {
        this.currentTime = ct - sum + r.end - r.start + r.start;
        //console.log("Current time is", this.currentTime, r);
      
       //  this.sessions=r.sessions;
        this.sessions = [];
         for (var i =0;i<r.sessions.length;i++){
          this.sessions.push(JSON.parse(r.sessions[i]));
        }
         this.startTime = r.start;
         this.end = r.end;
    
         r.currentStateProccessed = false;
         r.processStatesAfterSeek = true;
        //}, 50);
        
        currentRecord = r;
      //  this.end = 0;
      this.reload = true;
        break;
      }
      seekedNext++;
    }
    
    this.next = seekedNext;
    this.disposePlayers();
    this.peers = [];
 //this.end = currentRecord.end;
    var self = this;
    //setTimeout(function(){
     this.clearLastObjects();
     this.draw(currentRecord);
     // this.startPlaying();
          //self.playInSeek(currentRecord);
          /*function () {
      try {
    
     ///   self.startPlaying();
      } catch (err) { }
    });*/
  //},100);
  }
  getCurrentTime() {
    return this.currentTime;
  }
  clearLastObjects(){
    this.lastColumns={};
     this.lastState={};
  }
}


// WEBPACK FOOTER //
// /app/src/app/wb/player/replayer.service.ts